import Vue from 'vue'

export default {
    videoEvent(eventName, additionalDebugParams) {
        logEvent('video', eventName, additionalDebugParams)
    },

    navigationEvent(eventName, additionalDebugParams) {
        logEvent('navigation', eventName, additionalDebugParams)
    },

    actionEvent(eventName, additionalDebugParams) {
        logEvent('action', eventName, additionalDebugParams)
    }
}

function logEvent(eventCategory, eventName, additionalDebugParams) {
    Vue.$ga.event({
        eventCategory: eventCategory,
        eventAction: eventName,
        eventLabel: eventName,
        eventValue: additionalDebugParams
    })
}

